import ChatMessageList from '../components/chat/ChatMessageList';
import ChatInput from '../components/chat/ChatInput';

export default function ChatPage() {
  return (
    <div className="flex-1 flex overflow-hidden">
      {/* Main chat area */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Messages */}
        <ChatMessageList />

        {/* Input */}
        <ChatInput />
      </div>
    </div>
  );
}
